import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {useTheme} from '@mui/material/styles';
import {Dialog} from 'wobi-web-common/dist/v2/index.js';

import FirstStep from './FirstStep';
import SecondStep from './SecondStep';

const steps = [FirstStep, SecondStep];

function UnsupportedMedicalCases({isModalShow, close, values, hideContactPassportCard}) {
  const intl = useIntl();
  const theme = useTheme();
  const [step, setStep] = useState(0);
  const CurrentStep = steps[step];
  const increaseStep = () => setStep(step + 1);

  const onClose = () => {
    setStep(0);
    close();
  };

  if (!CurrentStep) {
    onClose();
    return null;
  }

  if (!isModalShow) return null;

  return (
    <Dialog
      open={isModalShow}
      onClose={onClose}
      title={intl.formatMessage({id: 'unsupported_medical_cases_modal.title'})}
      titleColor={theme.palette.secondary.main}
      centeredHeader
      ariaLabel={intl.formatMessage({id: 'unsupported_medical_cases_modal.title'})}
      width={480}
      style={{textAlign: 'center'}}
    >
      <div data-testid='modal-popup' style={{paddingTop: 4}}>
        <CurrentStep increaseStep={increaseStep} values={values} hideContactPassportCard={hideContactPassportCard} />
      </div>
    </Dialog>
  );
}

UnsupportedMedicalCases.propTypes = {
  isModalShow: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  hideContactPassportCard: PropTypes.bool,
};

UnsupportedMedicalCases.defaultProps = {
  hideContactPassportCard: false,
};

export default UnsupportedMedicalCases;

